import React, { useContext } from 'react';
import cn from 'clsx';
import { string } from 'prop-types';
import { useTranslation } from 'react-i18next';
import Link from '../../atoms/Link/index.jsx';
import PopupContext from '../../context/PopupContext.js';
import PopupBackdrop from '../../atoms/PopupBackdrop/index.jsx';
var _ref = /*#__PURE__*/React.createElement("div", {
  className: "auth-drop-down__separator"
});
const AuthDropDown = ({
  className,
  signInUrl,
  registerUrl
}) => {
  const {
    activePopup,
    popupKeys
  } = useContext(PopupContext);
  const {
    t
  } = useTranslation();
  const open = activePopup === popupKeys.account;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: `${popupKeys.account}-popup`,
    className: cn('auth-drop-down', className, open && 'auth-drop-down--open')
  }, /*#__PURE__*/React.createElement(Link, {
    href: signInUrl,
    className: "auth-drop-down__link"
  }, t('molecules.authDropDown.signInText')), _ref, /*#__PURE__*/React.createElement(Link, {
    href: registerUrl,
    className: "auth-drop-down__link"
  }, t('molecules.authDropDown.registerText'))), /*#__PURE__*/React.createElement(PopupBackdrop, {
    active: open,
    className: "auth-drop-down__backdrop"
  }));
};
AuthDropDown.defaultProps = {
  className: null
};
AuthDropDown.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional class names to add to the component root. */
  className: string,
  /** The URL to navigate to for signing in. */
  signInUrl: string.isRequired,
  /** The URL to navigate to for registering. */
  registerUrl: string.isRequired
} : {};
export default AuthDropDown;